export enum DoorType {
  QuadrilateralGarageDoor = "QuadrilateralGarageDoor",
  ChamferedGarageDoor = "ChamferedGarageDoor",
  ArchedGarageDoor = "ArchedGarageDoor",
}
